<template>
    <form-save 
        modelName="Tipo de Não Conformidade" 
        saveUrl="nonconformity-types/" 
        operation="post"
        id=""
        backUrl="/nonconformity-types"
        icon="fa-list-ul"
        ></form-save>
</template>

<script>
import FormSave from "./FormSave";
export default {
  components: {
    FormSave
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NonconformityType/Add.vue